const uk = {
  brand: "E2 Care",
  tagline: "Спокійний, поєднаний догляд.",
  nav_dashboard: "Панель",
  nav_residents: "Пацієнти",
  nav_patients: "Пацієнти",
  nav_rooms: "Кімнати",
  nav_devices: "Пристрої",
  nav_events: "Події",
  nav_alerts: "Сповіщення",
  nav_users: "Команда",
  nav_settings: "Налаштування",
  nav_admin: "Адміністрування",
  nav_signout: "Вийти",
  topbar_search_placeholder: "Пошук пацієнтів, кімнат, пристроїв…",
  admin_super_only: "Лише суперадміністратори можуть керувати організаціями.",
  admin_admin_only: "Лише адміністратори мають доступ до цієї сторінки.",
  admin_tab_orgs: "Організації",
  admin_tab_users: "Користувачі",
  admin_tab_patients: "Пацієнти",
  admin_tab_rooms: "Кімнати",
  admin_tab_buildings: "Будівлі",
  admin_tab_devices: "Пристрої",
  admin_tab_alerts: "Сповіщення",
  admin_tab_qa: "Тестові інструменти",
  admin_delete: "Видалити",
  admin_no_orgs_yet: "Ще немає організацій.",
  admin_field_name: "Ім’я",
  admin_field_email: "Ел. пошта",
  admin_field_phone: "Телефон",
  admin_field_password: "Пароль",
  admin_field_role: "Роль",
  admin_field_type: "Тип",
  admin_field_timezone: "Часовий пояс",
  admin_field_address: "Адреса",
  admin_field_status: "Статус",
  admin_field_organization: "Організація",
  admin_password_keep: "Залиште порожнім, щоб зберегти поточний",
  admin_field_birth_date: "Дата народження",
  admin_field_room: "Кімната",
  admin_field_room_none: "Не призначено",
  admin_field_photo: "URL фото",
  admin_field_photo_hint: "Вставте публічний URL зображення — повне завантаження у версії 2.",
  admin_field_notes: "Нотатки доглядальника",
  admin_field_emergency_contact: "Основний екстрений контакт",
  admin_field_ec_name: "Ім’я",
  admin_field_ec_phone: "Телефон",
  admin_field_ec_relationship: "Спорідненість",
  admin_field_mac: "MAC-адреса",
  admin_field_firmware: "Прошивка",
  admin_field_assignment: "Призначено",
  admin_field_assigned_room: "Призначена кімната",
  admin_field_assigned_patient: "Призначений пацієнт",
  admin_field_assigned_hint: "Необов’язково. Датчики зазвичай прикріплюють до кімнати, браслети — до пацієнта.",
  admin_field_sensor_target: "Встановлено на",
  admin_field_sensor_target_hint: "Повідомляє системі, чи цей датчик стежить за дверима, чи за вікном.",
  sensor_target_door: "Двері",
  sensor_target_window: "Вікно",
  sensor_target_unset: "Не налаштовано",
  admin_field_sensor_label: "Мітка датчика",
  admin_field_sensor_label_hint: "Зручна назва, що відображається у сповіщеннях і подіях — напр. «Вхідні двері», «Вікно ванної».",
  admin_field_building: "Будівля",
  admin_field_building_required: "Кімната має належати до будівлі.",
  room_openings: "Отвори",
  room_no_openings: "У цій кімнаті ще не встановлено датчиків дверей або вікон.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Остання зміна",
  admin_field_description: "Опис",
  admin_field_severity: "Рівень важливості",
  admin_field_patient: "Пацієнт",
  admin_field_device: "Пристрій",
  admin_field_message: "Повідомлення",
  admin_orgs_title: "Організації",
  admin_orgs_sub: "Створюйте, редагуйте та архівуйте орендарів E2 Care.",
  admin_orgs_count: "організації",
  admin_org_new: "Нова організація",
  admin_org_new_title: "Нова організація",
  admin_org_edit_title: "Редагувати організацію",
  admin_org_created: "Організацію створено.",
  admin_org_updated: "Організацію оновлено.",
  admin_org_deleted: "Організацію заархівовано.",
  admin_org_delete_title: "Заархівувати організацію?",
  admin_org_delete_confirm: "Це приховає «{name}» зі списків. За потреби її можна відновити з бази даних.",
  admin_users_title: "Користувачі",
  admin_users_sub_super: "Керуйте всіма обліковими записами користувачів у всіх орендарів.",
  admin_users_sub_org: "Керуйте обліковими записами користувачів для {org}.",
  admin_user_new: "Новий користувач",
  admin_user_new_title: "Новий користувач",
  admin_user_edit_title: "Редагувати користувача",
  admin_user_created: "Користувача створено.",
  admin_user_updated: "Користувача оновлено.",
  admin_user_deleted: "Користувача заархівовано.",
  admin_user_delete_title: "Заархівувати користувача?",
  admin_user_delete_confirm: "«{name}» втратить доступ. Активні сеанси не завершуються.",
  admin_user_memberships: "Членство в організаціях",
  admin_patients_title: "Пацієнти",
  admin_patients_sub_super: "Керуйте всіма картками пацієнтів у всіх орендарів.",
  admin_patients_sub_org: "Керуйте картками пацієнтів у {org}.",
  admin_patient_new: "Новий пацієнт",
  admin_patient_new_title: "Новий пацієнт",
  admin_patient_edit_title: "Редагувати пацієнта",
  admin_patient_created: "Пацієнта створено.",
  admin_patient_updated: "Пацієнта оновлено.",
  admin_patient_deleted: "Пацієнта заархівовано.",
  admin_patient_delete_title: "Заархівувати пацієнта?",
  admin_patient_delete_confirm: "«{name}» буде приховано зі списків. Зв’язки з командою догляду та родиною збережено.",
  admin_rooms_title: "Кімнати",
  admin_rooms_sub_super: "Налаштовуйте кімнати у всіх орендарів.",
  admin_rooms_sub_org: "Налаштовуйте кімнати у {org}.",
  admin_room_new: "Нова кімната",
  admin_room_new_title: "Нова кімната",
  admin_room_edit_title: "Редагувати кімнату",
  admin_room_created: "Кімнату створено.",
  admin_room_updated: "Кімнату оновлено.",
  admin_room_deleted: "Кімнату заархівовано.",
  admin_room_delete_title: "Заархівувати кімнату?",
  admin_room_delete_confirm: "«{name}» буде приховано. Наявні пацієнти зберігають посилання assigned_room_id.",
  admin_devices_title: "Пристрої",
  admin_devices_sub_super: "Надавайте пристрої Moko у всіх орендарів.",
  admin_devices_sub_org: "Надавайте пристрої Moko у {org}.",
  admin_device_new: "Новий пристрій",
  admin_device_new_title: "Новий пристрій",
  admin_device_edit_title: "Редагувати пристрій",
  admin_device_created: "Пристрій створено.",
  admin_device_updated: "Пристрій оновлено.",
  admin_device_deleted: "Пристрій заархівовано.",
  admin_device_delete_title: "Заархівувати пристрій?",
  admin_device_delete_confirm: "Пристрій {mac} буде приховано. Минулі події та сповіщення залишаються в історії.",
  admin_buildings_title: "Будівлі",
  admin_buildings_sub_super: "Групуйте кімнати за фізичною будівлею / крилом у всіх орендарів.",
  admin_buildings_sub_org: "Групуйте кімнати за фізичною будівлею / крилом у {org}.",
  admin_building_new: "Нова будівля",
  admin_building_new_title: "Нова будівля",
  admin_building_edit_title: "Редагувати будівлю",
  admin_building_created: "Будівлю створено.",
  admin_building_updated: "Будівлю оновлено.",
  admin_building_deleted: "Будівлю заархівовано.",
  admin_building_delete_title: "Заархівувати будівлю?",
  admin_building_delete_confirm: "«{name}» буде приховано. Кімнати зберігають посилання corpus_id.",
  admin_qa_title: "Тестові інструменти",
  admin_qa_sub: "Впроваджуйте події / сповіщення, щоб перевірити панель, розсилання сповіщень і канали повідомлень без використання справжніх пристроїв Moko.",
  admin_qa_event_title: "Впровадити тестову подію",
  admin_qa_event_sub: "Симулює вебхук пристрою Moko. Бекенд запустить свій конвеєр розсилання сповіщень, ніби подія надійшла зі справжнього обладнання.",
  admin_qa_alert_title: "Впровадити тестове сповіщення",
  admin_qa_alert_sub: "Пропускає рівень подій і записує сповіщення напряму. Використовуйте для перевірки дзвіночка, списку та розсилання Slack/Telegram.",
  admin_qa_inject_event: "Впровадити подію",
  admin_qa_inject_alert: "Впровадити сповіщення",
  admin_qa_event_done: "Подію впроваджено. Слідкуйте за сторінкою Події та панеллю.",
  admin_qa_alert_done: "Сповіщення впроваджено. Слідкуйте за дзвіночком.",
  admin_qa_disclaimer: "Ці кінцеві точки слід вимкнути або позначити прапорцем у продакшені.",
  admin_alerts_title: "Політика сповіщень",
  admin_alerts_sub: "Правила сповіщень для всієї {org}. Застосовуються до кожного пацієнта цього орендаря.",
  admin_alerts_quiet_title: "Тихі години",
  admin_alerts_quiet_desc: "Визначте, коли ця організація перебуває в «нічному режимі». Корисно для тихішого маршрутування некритичних сповіщень.",
  admin_alerts_quiet_hint: "Час інтерпретується в локальному часовому поясі організації. Діапазон може переходити північ (напр. 22:00 → 06:00).",
  admin_alerts_night_start: "Ніч починається",
  admin_alerts_night_end: "Ніч закінчується",
  admin_alerts_load_failed: "Завантажити політику сповіщень",
  admin_alerts_save_failed: "Зберегти політику сповіщень",
  admin_alerts_saved: "Політику сповіщень збережено.",
  admin_alerts_clear_title: "Очистити активні сповіщення",
  admin_alerts_clear_desc: "Підтвердьте всі відкриті сповіщення цієї організації одним кліком.",
  admin_alerts_clear_hint: "Корисно після запланованого навчання або неправильно налаштованого датчика, що спричинив хвилю хибних спрацювань. Підтверджені сповіщення залишаються в історії.",
  admin_alerts_ack_all_button: "Підтвердити всі",
  admin_alerts_ack_all_title: "Підтвердити всі активні сповіщення?",
  admin_alerts_ack_all_confirm: "Це позначить як підтверджене кожне відкрите сповіщення в {org}. Цю дію не можна скасувати.",
  admin_alerts_ack_all_done: "Підтверджено {count} сповіщення.",
  admin_alerts_ack_all_done_generic: "Усі активні сповіщення підтверджено.",
  admin_alerts_ack_all_failed: "Підтвердити всі сповіщення",
  org_type_nursing_home: "Будинок престарілих",
  org_type_assisted_living: "Житло з підтримкою",
  org_type_hospital: "Лікарня",
  org_type_home_care: "Домашній догляд",
  role_admin: "Адміністратор",
  role_caregiver: "Доглядальник",
  role_family: "Родина",
  status_active: "активний",
  status_inactive: "неактивний",
  confirm: "Підтвердити",
  sign_in: "Увійти",
  signed_in: "Вхід виконано",
  sign_up: "Зареєструватися",
  email: "Ел. пошта",
  password: "Пароль",
  full_name: "Повне ім’я",
  create_account: "Створити обліковий запис",
  no_account: "Ще немає облікового запису?",
  have_account: "Вже маєте обліковий запис?",
  login_welcome: "З поверненням",
  login_sub: "Увійдіть, щоб продовжити моніторинг ваших підопічних.",
  register_welcome: "Приєднуйтесь до E2 Care",
  register_sub: "Створіть свій робочий простір доглядальника менш ніж за хвилину.",
  total_residents: "Пацієнти",
  active_devices: "Активні пристрої",
  open_alerts: "Відкриті сповіщення",
  offline_gateways: "Пристрої офлайн",
  falls_7d: "Падіння (7 дн)",
  sos_7d: "SOS (7 дн)",
  low_battery: "Низький заряд",
  critical_residents: "Критичні",
  status_ok: "Все гаразд",
  status_warning: "Увага",
  status_critical: "Критичний",
  status_online: "Онлайн",
  status_offline: "Офлайн",
  search: "Пошук",
  filter: "Фільтр",
  all: "Усі",
  refresh: "Оновити",
  loading: "Завантаження…",
  no_results: "Тут поки нічого немає.",
  view_profile: "Переглянути профіль",
  showing_n_of_m: "Показано {n} з {m}",
  load_more: "Завантажити ще",
  auto_refresh: "У реальному часі · автооновлення",
  auto_refresh_paused: "Призупинено (активне завантаження ще)",
  updated_just_now: "Оновлено щойно",
  updated_n_sec_ago: "Оновлено {n} с тому",
  updated_n_min_ago: "Оновлено {n} хв тому",
  acknowledge: "Підтвердити",
  acknowledged: "Підтверджено",
  ack_all: "Підтвердити всі",
  ack_all_confirm: "Підтвердити всі {count} активні сповіщення?",
  ack_all_running: "Підтвердження…",
  ack_all_done: "Підтверджено {count} сповіщень.",
  ack_all_partial: "{ok} підтверджено · {fail} не вдалося.",
  last_seen: "Востаннє в мережі",
  battery: "Батарея",
  signal: "Сигнал",
  firmware: "Прошивка",
  room: "Кв. / Кімната",
  age: "Вік",
  emergency_contact: "Екстрений контакт",
  notes: "Нотатки",
  assigned_devices: "Призначені пристрої",
  recent_events: "Останні події",
  timeline_24h: "Останні 24 години",
  delivery_status: "Статус доставки",
  acknowledged_by: "Підтверджено",
  dashboard_title: "Огляд будинку",
  dashboard_sub: "Швидкий огляд усього, що відбувається в будинках, за якими ви доглядаєте.",
  residents_title: "Пацієнти",
  residents_sub: "Люди, яких ви зараз моніторите.",
  devices_title: "Пристрої",
  devices_sub: "Датчики й теги.",
  devices_sub_admin: "Шлюзи, датчики й теги.",
  events_title: "Події наживо",
  events_sub: "Хронологічна стрічка з кожного підключеного пристрою.",
  alerts_title: "Сповіщення",
  alerts_sub: "Повідомлення, ескальовані до родини та доглядальників.",
  settings_title: "Налаштування",
  settings_sub: "Ваші вподобання та правила сповіщень.",
  users_title: "Команда",
  users_sub: "Доглядальники, родина й адміністратори з доступом.",
  falls_chart_title: "Падіння та SOS — останні 7 днів",
  recent_alerts_title: "Останні критичні сповіщення",
  no_alerts: "Немає відкритих сповіщень. Усі в безпеці.",
  event_fall: "Виявлено падіння",
  event_sos: "Натиснуто кнопку SOS",
  event_door_open: "Двері відчинено",
  event_door_close: "Двері зачинено",
  event_inactivity: "Тривала бездіяльність",
  event_low_battery: "Низький заряд",
  event_offline: "Пристрій офлайн",
  event_online: "Пристрій знову онлайн",
  event_heartbeat: "Сигнал активності",
  event_button_press: "Натиснуто кнопку",
  device_gateway: "Шлюз Bluetooth",
  device_door_sensor: "Датчик дверей",
  device_bracelet: "Браслет",
  device_unknown: "Невідомий пристрій",
  language: "Мова",
  notifications: "Сповіщення",
  quiet_hours: "Тихі години",
  escalation: "Політика ескалації",
  just_now: "щойно",
  rel_prefix: "",
  min_ago: "хв тому",
  h_ago: "год тому",
  d_ago: "дн тому",
  demo_hint: "Демо-акаунт: admin@e2care.lv / Care2024!",
  open_menu: "Відкрити меню",
  close_menu: "Закрити меню",
  care_team: "Команда догляду",
  family_members: "Родина",
  no_caregivers: "Доглядальників ще не призначено.",
  no_family: "Членів родини ще не пов’язано.",
  add_caregiver: "Додати доглядальника",
  add_family: "Додати члена родини",
  select_user: "Виберіть користувача…",
  cancel: "Скасувати",
  add: "Додати",
  remove: "Видалити",
  save: "Зберегти",
  relationship: "Спорідненість",
  relationship_son: "Син",
  relationship_daughter: "Дочка",
  relationship_spouse: "Чоловік/дружина",
  relationship_other: "Інше",
  notify_via: "Сповіщати через",
  call_contact: "Зателефонувати контакту",
  view_resident: "Відкрити профіль",
  address: "Адреса",
  admin_only_section: "Інструменти адміністратора",
  rooms_title: "Кімнати",
  rooms_sub: "Кожна кімната під вашим наглядом — пацієнти, пристрої та поточний стан.",
  room_name: "Кімната",
  room_type: "Тип",
  room_type_private_room: "Окрема кімната",
  room_type_shared_room: "Спільна кімната",
  room_type_apartment: "Квартира",
  room_type_corridor: "Коридор",
  room_type_common_area: "Спільна зона",
  room_floor: "Поверх",
  room_state: "Поточний стан",
  door: "Двері",
  window: "Вікно",
  door_open_state: "Відчинено",
  door_closed_state: "Зачинено",
  door_unknown_state: "Невідомо",
  room_no_devices: "У цій кімнаті ще немає пристроїв.",
  room_no_patients: "До цієї кімнати ще не призначено пацієнтів.",
  room_patients: "Пацієнти в кімнаті",
  room_devices: "Пристрої в кімнаті",
  room_activity: "Хронологія активності",
  rooms_filter_all_types: "Усі типи",
  widget_active_alerts: "Активні сповіщення",
  widget_active_alerts_sub: "Критичні, невирішені та підтверджені",
  widget_patients_status: "Статус пацієнтів",
  widget_devices_health: "Стан пристроїв",
  widget_room_activity: "Активність кімнат",
  widget_recent_events: "Стрічка подій наживо",
  widget_connectivity: "Зв’язок",
  metric_critical: "Критичні",
  metric_unresolved: "Невирішені",
  metric_acknowledged_count: "Підтверджені",
  metric_total: "Усього",
  metric_active: "Активні",
  metric_online: "Онлайн",
  metric_offline: "Офлайн",
  metric_ota_pending: "OTA очікує",
  metric_battery_warn: "Низька батарея",
  metric_doors_open: "Відчинені двері",
  metric_windows_open: "Відчинені вікна",
  metric_signal_avg: "Сер. сигнал",
  metric_last_comm: "Останній зв’язок",
  metric_packets: "Пакети / год",
  view_all: "Переглянути всі",
  status_new: "Новий",
  status_acknowledged: "Підтверджений",
  status_resolved: "Вирішений",
  status_resolved_local: "Вирішено (локально)",
  resolve: "Вирішити",
  add_note: "Додати нотатку",
  save_note: "Зберегти нотатку",
  resolve_local_badge: "лише цей пристрій",
  resolve_local_hint: "Позначає сповіщення як вирішене лише у вашому браузері. Сервер та інші члени команди досі бачать його як відкрите.",
  note_placeholder: "Додайте контекст для команди…",
  notes_count: "{n} нотаток",
  device_detail: "Деталі пристрою",
  device_diagnostics: "Діагностика",
  device_firmware_history: "Історія прошивки",
  device_ota_config: "Конфігурація OTA",
  device_ota_status: "Статус OTA",
  device_signal: "Якість сигналу",
  device_mac: "MAC-адреса",
  device_serial: "Серійний номер",
  fall_sensitivity: "Чутливість виявлення падіння",
  transmission_interval: "Інтервал передачі",
  low_battery_threshold: "Поріг низького заряду",
  ota_idle: "Очікування",
  ota_pending: "Очікує",
  ota_deploying: "Розгортання",
  ota_failed: "Помилка",
  events_filter_severity: "Важливість",
  events_filter_room: "Кімната",
  events_filter_patient: "Пацієнт",
  events_filter_device: "Пристрій",
  severity_info: "Інфо",
  severity_warning: "Попередження",
  severity_critical: "Критичний",
  telegram_title: "Сповіщення Telegram",
  telegram_desc: "Отримуйте сповіщення в Telegram для призначених вам підопічних.",
  telegram_connect: "Підключити Telegram",
  telegram_connected: "Telegram підключено",
  telegram_connected_as: "Підключено до Telegram як {name}",
  telegram_connect_success: "Telegram успішно підключено",
  telegram_connect_error: "Не вдалося підключити Telegram. Спробуйте ще раз.",
  telegram_missing_bot: "Бот Telegram не налаштовано. Встановіть REACT_APP_TELEGRAM_BOT у файлі env.",
  telegram_disconnect: "Відключити",
  telegram_disconnect_success: "Telegram відключено.",
  telegram_disconnect_error: "Не вдалося відключити Telegram. Спробуйте ще раз.",
  telegram_already_linked: "Цей акаунт Telegram уже пов’язаний з іншим користувачем e2-care.",
  telegram_switch_q: "Використати інший акаунт Telegram?",
  telegram_switch_intro: "Telegram запам’ятовує, який акаунт увійшов на всіх сайтах. Щоб використати інший:",
  telegram_switch_step1: "Відкрийте Telegram Web і вийдіть із поточного акаунта.",
  telegram_switch_step2: "Поверніться сюди та перезавантажте кнопку нижче, потім увійдіть іншим акаунтом.",
  telegram_open_web: "Відкрити Telegram Web",
  telegram_reload_widget: "Я вийшов — перезавантажити кнопку",
  lang_autodetected_toast: "Виявлено вашу мову як {language}. Ви можете змінити її в Налаштуваннях.",
  admin_view_active: "Активні",
  admin_view_archived: "Заархівовані",
  admin_restore: "Відновити",
  admin_restored: "Відновлено.",
  admin_hard_delete: "Видалити назавжди",
  admin_hard_delete_title: "Видалити назавжди?",
  admin_hard_delete_confirm: "Це назавжди видалить «{name}» з бази даних. Цю дію не можна скасувати.",
  admin_hard_deleted: "Видалено назавжди.",
  admin_no_archived: "Немає заархівованих елементів.",
  language_desc: "Використовується для інтерфейсу застосунку та ваших сповіщень Telegram + push.",
  language_saved: "Мову оновлено.",
  language_error: "Не вдалося оновити мову. Спробуйте ще раз.",
  admin_field_language: "Мова",
  edit: "Редагувати",
  generic_error: "Щось пішло не так. Спробуйте ще раз.",
  caregiver_added: "Доглядальника додано.",
  caregiver_removed: "Доглядальника видалено.",
  family_added: "Члена родини додано.",
  family_removed: "Члена родини видалено.",
  menu: "Меню",
  dl_companion_app: "Супутній застосунок",
  dl_hero_title: "E2 Care для Android",
  dl_hero_sub: "Встановіть супутній застосунок на телефон із Moko, щоб ретранслювати сповіщення, налаштовувати пристрої та залишатися на зв’язку з командою догляду — навіть коли панель закрита.",
  dl_android_apk: "APK Android",
  dl_version_loading: "завантаження версії…",
  dl_released: "Випущено {date}",
  dl_download_apk: "Завантажити APK",
  dl_unavailable: "Недоступно",
  dl_preparing: "Підготовка…",
  dl_manifest_error: "Не вдалося завантажити маніфест. Спробуйте оновити — якщо проблема не зникає, сервер збірки може перерозгортатися.",
  dl_whats_new: "Що нового",
  dl_installing_title: "Встановлення на телефон",
  dl_step1: "Натисніть «Завантажити APK» вище. Ваш браузер може попередити, що файли APK можуть зашкодити пристрою — це попередження є нормальним для будь-якого інсталятора, завантаженого поза Play Store.",
  dl_step2: "Відкрийте завантажений файл. Android попросить дозволити встановлення з цього браузера вперше — увімкніть дозвіл і поверніться.",
  dl_step3: "Натисніть «Встановити», а потім «Відкрити» після завершення.",
  dl_step4: "Увійдіть за допомогою своїх облікових даних E2 Care.",
  dl_iphone_note: "Версія для iPhone з’явиться пізніше. Наразі скористайтеся вебпанеллю.",
  dl_back_to_dashboard: "Назад до панелі",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Зміна організації очищає поточне призначення кімнати та пацієнта.",
  admin_view_full: "Повний список",
  device_filter_assignment: "Призначення",
  device_filter_patient: "Призначено пацієнту",
  device_filter_room: "Призначено кімнаті",
  device_filter_unassigned: "Не призначено",
  admin_all_orgs: "Усі організації",
  pagination_prev: "Попередня",
  pagination_next: "Наступна",
  pagination_per_page: "На сторінці",
  pagination_page_of: "Сторінка {page} з {pages}",
  pagination_total: "Усього {total}",
  event_charging: "Заряджання розпочато",
  event_sos_cancel: "SOS скасовано",
  event_call: "SOS-виклик",
  device_personal_alarm: "Персональна тривога",
  device_charging: "Заряджається",
  device_location: "Місцезнаходження",
  device_current_location: "Поточне місцезнаходження",
  device_no_location: "Місцезнаходження ще не повідомлено.",
  device_location_source: "Джерело",
  device_location_updated: "Оновлено",
  device_track_1h: "1 год",
  device_track_24h: "24 год",
  device_track_7d: "7 дн",
  device_track_last: "Остання позиція",
  device_located: "Знайдено",
  map_sos: "Сигнал SOS",
  map_fall: "Виявлено падіння",
  map_current: "Поточна позиція",
  alert_timeline: "Хронологія тривоги",
  alert_trigger: "Тригер",
  alert_calls: "Дзвінки",
  alert_view_timeline: "Переглянути хронологію",
  alert_no_deliveries: "Сповіщення ще не надіслані.",
  alert_cancelled_on_device: "SOS було скасовано на пристрої — тривога залишається відкритою, доки доглядальник її не вирішить.",
  call_answered: "Прийнято",
  call_missed: "Пропущено",
  reopen: "Відкрити знову",
  reopened: "Тривогу відкрито знову",
  live: "Наживо",
  nav_home: "Головна",
  family_home_kicker: "Перегляд для родини",
  family_home_title: "Ваші близькі",
  family_greeting: "Вітаємо",
  family_home_sub: "Спокійний огляд того, як почувається кожен.",
  family_status_ok: "почувається добре",
  family_status_attention: "потребує уваги",
  family_all_calm: "Наразі все спокійно.",
  family_attention_sub: "Перевірмо, як він — деталі нижче.",
  family_last_seen: "востаннє бачили",
  family_latest_alert: "Остання тривога",
  family_no_alerts: "Немає нещодавніх тривог — усе гаразд.",
  family_view_details: "Переглянути деталі",
  family_no_device: "Персональна тривога ще не прив'язана.",
  status_never_reported: "Ніколи не звітував",
  mv_title: "Рух",
  mv_sub: "З {n} датчика(ів) руху · 5-хвилинні вікна",
  mvo_title: "Рух з першого погляду",
  mvs_moving: "{name} на ногах",
  mvs_moving_sub: "Рух {when}",
  mvs_rest: "{name} відпочиває",
  mvs_rest_sub: "Останній рух {when}",
  mvs_rest_sub_none: "Немає руху за останні 30 днів",
  mvs_quiet: "{name}: немає руху довше, ніж зазвичай",
  mvs_quiet_sub: "Немає руху вже {dur}. Можливо, варто зателефонувати.",
  mvs_short_quiet: "Довго без руху",
  mvs_room_moving: "Хтось рухається в приміщенні {name}",
  mvs_room_rest: "У приміщенні {name} спокійно",
  mvs_room_quiet: "У приміщенні {name} немає руху довше, ніж зазвичай",
  mvs_sensor: "Датчик руху не передає дані",
  mvs_sensor_sub: "Це стосується датчика, а не {name}. Останній сигнал {when}.",
  mvs_nodata: "Даних про рух ще немає",
  mvs_nodata_sub: "Датчик руху ще нічого не передав.",
  mvd_title: "Останні 24 години",
  mvd_moving: "Рух",
  mvd_resting: "Відпочинок",
  mvd_nosignal: "Немає сигналу",
  mvd_night: "Ніч",
  mvd_now: "Зараз",
  mvn_title: "Останні 7 ночей",
  mvn_last_night: "Минулої ночі",
  mvn_last_short: "Учора",
  mvn_calm: "Спокійна",
  mvn_restless: "Неспокійна",
  mvn_still: "Дуже тиха",
  mvn_silent: "Датчик мовчав",
  mvn_nodata: "Немає даних",
  mvn_s_calm_none: "Спокійна ніч, без руху з {from} до {to}.",
  mvn_s_calm_once: "Спокійна ніч, один підйом близько {at}.",
  mvn_s_calm_many: "Спокійна ніч, підйомів: {n}, перший близько {first}, останній близько {last}.",
  mvn_s_restless: "Неспокійна ніч, підйомів: {n} з {first} до {last}.",
  mvn_s_still: "Дуже тиха ніч, менше руху, ніж зазвичай. Найдовший відпочинок {dur}.",
  mvn_s_still_moved: "Дуже тиха ніч, рух лише близько {at}. Найдовший відпочинок {dur}.",
  mvn_s_silent: "Датчик майже мовчав, тому ми не можемо сказати, як минула ніч.",
  mvn_s_nodata: "Немає даних про рух за цю ніч.",
  mv_state_moving: "Рух",
  mv_state_still: "Відпочинок",
  mv_state_inactive: "Неактивний",
  mv_state_silent: "Датчик не передає дані",
  mv_state_never: "Ніколи не звітував",
  mv_state_nodata: "Даних ще немає",
  mv_state_no_sensor: "Немає датчика руху",
  mv_last_movement: "Останній рух",
  mv_last_sample: "Останній сигнал датчика",
  mv_none_in_retention: "Немає за останні 30 днів",
  mv_silent_hint: "Жодних даних понад {min} хв — перевірте датчик або його шлюз. Це несправність пристрою, а не нерухомість.",
  mv_inactive_hint: "Руху немає понад {min} хв, хоча датчик досі передає дані.",
  mv_history: "Історія руху",
  mv_history_empty: "За цей період даних про рух ще немає.",
  mv_not_reporting: "Не передає дані",
  mv_no_movement: "Руху немає",
  mv_detections: "виявлень руху",
  mv_legend_motion: "Виявлення руху",
  mv_legend_gap: "Не передає дані",
  mv_retention_note: "Історія зберігається 30 днів",
  mv_strip_title: "Рух у реальному часі",
  mv_strip_sub: "{n} датчик(ів) руху",
  mv_unassigned: "Непризначений датчик",
  admin_alerts_timezone: "Часовий пояс організації",
  admin_alerts_timezone_invalid: "Виберіть дійсний часовий пояс IANA.",
  admin_alerts_night_wrap_hint: "Нічні години тривають з {start} до {end} наступного ранку ({tz}), тобто після {start} або до {end}.",
  admin_alerts_night_same_day_hint: "Нічні години тривають з {start} до {end} того ж дня ({tz}).",
  admin_alerts_night_equal: "Початок і кінець не можуть збігатися.",
  admin_alerts_inactivity_label: "Поріг неактивності",
  admin_alerts_inactivity_question: "Чи рухалася ця людина? Хвилини без руху, після яких це стає приводом для тривоги.",
  admin_alerts_silence_label: "Поріг тиші пристрою",
  admin_alerts_silence_question: "Чи датчик ще на зв'язку? Хвилини без жодного сигналу, після яких це вважається несправністю пристрою, а не неактивним мешканцем.",
  admin_alerts_minutes: "хвилин",
  admin_alerts_threshold_invalid: "Введіть ціле число, більше за 0.",
  admin_alerts_thresholds_provisional: "Початкові значення (180 / 30 хв) ще не налаштовані — адаптуйте їх до своїх мешканців.",
  admin_tab_gateways: "Шлюзи",
  gw_title: "Шлюзи",
  gw_status_deactivated: "Вимкнено",
  gw_scope_pending: "Шлюзи вашої організації з'являться тут після оновлення бекенду.",
  gw_none_for_org: "До цієї організації ще не прив'язано жодного шлюзу.",
  gw_col_room: "Кімната",
  gw_unassigned: "Не призначено",
  gw_never: "Ніколи",
  gw_edit_title: "Змінити шлюз",
  gw_new_title: "Новий шлюз",
  gw_super_field: "Змінити може лише суперадміністратор",
  gw_mac_invalid: "Введіть 12 шістнадцяткових символів, напр. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Тип обладнання",
  gw_notes: "Нотатки",
  gw_manage_sub: "BLE-хаби, що передають дані датчиків: стан, організація та кімната. Шлюз, що мовчить, змушує «мовчати» всі датчики за ним.",
  gw_filter_all: "Усі організації",
  gw_new: "Новий шлюз",
  gw_col_assignment: "Організація · Кімната",
  gw_backend_pending: "Потрібне оновлення бекенду, яке ще не розгорнуто.",
  gw_save_failed: "Зберегти шлюз",
  gw_created: "Шлюз створено",
  gw_saved: "Шлюз збережено",
  gw_reactivated: "Шлюз знову ввімкнено",
  gw_deactivated: "Шлюз вимкнено",
  gw_reactivate: "Увімкнути знову",
  gw_deactivate: "Вимкнути",
  gw_reactivate_title: "Знову ввімкнути {name}?",
  gw_deactivate_title: "Вимкнути {name}?",
  gw_reactivate_desc: "Він знову враховуватиметься у стані та сповіщеннях.",
  gw_deactivate_desc: "Він більше не враховується у стані та сповіщеннях. Історія зберігається, його можна знову ввімкнути будь-коли.",
  gw_heard_title: "Пристрої, які він чує",
  gw_heard_sub: "Датчики, передані цим шлюзом за останні 24 години.",
  gw_heard_none: "За останні 24 години пристроїв немає.",
  gw_heard_unknown: "Невідомі пристрої",
  gw_msgs_short: "повід.",
  gw_avg: "сер.",
  gw_samples_short: "вимірів",
  gw_not_found: "Шлюз не знайдено або він вам не видимий.",
  gw_one: "Шлюз",
  gw_manage_link: "Керувати в Адмініструванні",
  gw_rssi_range: "Діапазон сигналу",
  gw_longest_gap: "Найдовша перерва",
  gw_config_push: "Останнє надсилання конфігурації",
  gw_sub: "BLE-хаби, що передають дані датчиків. Лише перегляд — мовчазний шлюз робить мовчазними всі датчики за ним.",
  gw_super_only: "Стан шлюзів доступний лише суперадміністраторам.",
  gw_load_failed: "Завантаження шлюзів",
  gw_status_reporting: "Звітує",
  gw_status_silent: "Мовчить",
  gw_status_never_seen: "Ніколи не бачили",
  gw_returned: "Повернувся після {h} год перерви (закінчилася {at})",
  gw_count_reporting: "{n} звітують",
  gw_count_silent: "{n} мовчать",
  gw_count_never: "{n} ніколи не бачили",
  gw_count_deactivated: "вимкнено: {n}",
  gw_window: "Застарілий після {h} год без повідомлень",
  gw_col_name: "Шлюз",
  gw_col_status: "Стан",
  gw_col_msgs: "Повідомлення 24 год",
  gw_col_discard: "Відкинуто",
  gw_last_message: "Останнє повідомлення",
  gw_devices_seen: "Побачені пристрої",
  gw_hours_active: "Активні години",
  gw_unregistered_title: "Звітує без запису в реєстрі",
  gw_unregistered_desc: "Ці ідентифікатори є в активності шлюзів, але не мають запису (напр., пристрій, що звітує під IMEI). Підсумки з двох джерел можуть обґрунтовано відрізнятися.",
  nav_reports: "Звіти",
  rep_night_title: "Нічний підсумок",
  rep_night_desc: "Ранковий підсумок руху кожного мешканця в нічні години організації та періодів тиші датчиків.",
  rep_last_night: "Минула ніч",
  rep_nights_ago: "{n} ночі тому",
  rep_policy_fallback: "нічні години за замовчуванням (політика недоступна)",
  rep_movement: "Рух",
  rep_windows: "{n} активних 5-хв вікон",
  rep_no_movement: "Руху немає",
  rep_first_movement: "Перший рух",
  rep_longest_still: "Найдовша нерухомість",
  rep_silences: "Тиша датчика",
  rep_none: "Немає",
  rep_coverage: "{pct}% отримано",
  rep_night_note: "Час указано в часовому поясі організації. Нерухомість враховується лише коли датчик передає дані; періоди тиші від порогу тиші наведено окремо.",
  dh_reporting_title: "Стан звітування",
  dh_never_reported_desc: "Зареєстровано, але ніколи не звітувало. Це незавершене встановлення, а не пристрій офлайн.",
  dh_interval_still: "Виміряний інтервал (у спокої)",
  dh_interval_moving: "Виміряний інтервал (у русі)",
  dh_interval_samples: "Зразки вимірювань",
  dh_interval_unmeasured: "Виміряного інтервалу ще немає — застосовується поріг тиші організації.",
  dh_interval_note: "Інтервали вимірюються за отриманими повідомленнями, а не за налаштованим значенням.",
  rep_dur_h_min: "{h} год {m} хв",
  rep_dur_min: "{m} хв",
  rep_shared_room: "Спільна кімната — може включати рух інших",
  rep_no_data_night: "Немає даних за цю ніч — датчик не передавав дані (або ще не був встановлений).",
  nav_buildings: "Будівлі",
  imei_label: "IMEI",
  imei_hint: "15 цифр, надрукованих на звороті пристрою",
  imei_length: "IMEI містить 15 цифр",
  imei_invalid: "Цей IMEI недійсний. Перевірте цифри",
  imei_resident_note: "Тривожна кнопка супроводжує мешканця, тому не прив'язується до кімнати.",
  imei_online_hint: "Пристрій з'являється онлайн після першого сигналу, приблизно через 5 хвилин після ввімкнення.",
  forgot_link: "Забули пароль? Натисніть тут",
  forgot_title: "Скинути пароль",
  forgot_sub: "Введіть email, і ми надішлемо посилання для скидання пароля.",
  forgot_submit: "Надіслати посилання",
  forgot_sent: "Якщо обліковий запис із цим email існує, ми надіслали посилання для скидання пароля. Перевірте пошту.",
  forgot_back: "← Назад до входу",
  reset_title: "Встановіть новий пароль",
  reset_sub: "Виберіть новий пароль для облікового запису.",
  reset_new_password: "Новий пароль",
  reset_confirm_password: "Підтвердіть пароль",
  reset_hint: "Щонайменше 8 символів.",
  reset_submit: "Оновити пароль",
  reset_success: "Пароль оновлено. Перенаправлення до входу…",
  reset_too_short: "Пароль має містити щонайменше 8 символів.",
  reset_mismatch: "Паролі не збігаються.",
  reset_no_token: "Посилання недійсне або відсутнє. Запросіть нове на сторінці входу.",
  reset_failed: "Посилання недійсне або прострочене. Запросіть нове.",
  admin_tab_device_types: "Типи пристроїв",
  admin_dt_title: "Типи пристроїв",
  admin_dt_sub: "Каталог моделей пристроїв. Перейменуйте відображувану назву типу — внутрішній ключ, IoT-відповідність і синхронізація не змінюються.",
  admin_dt_col_label: "Відображувана назва",
  admin_dt_col_key: "Внутрішній ключ",
  admin_dt_col_category: "Категорія",
  admin_dt_col_wearable: "Носимий",
  admin_dt_col_ble_sync: "BLE-синхронізація",
  admin_dt_col_ble_type_id: "ID типу BLE",
  admin_dt_wearable_yes: "Носить мешканець",
  admin_dt_wearable_no: "Стаціонарний",
  admin_dt_ble_sync_on: "Потрібна",
  admin_dt_ble_sync_off: "Вимкнено",
  admin_dt_edit_label: "Змінити назву",
  admin_dt_edit_title: "Перейменувати",
  admin_dt_edit_desc: "Змінюється лише зрозуміла назва. Пристрої, фільтри та інтеграції й надалі використовують внутрішній ключ «{key}».",
  admin_dt_label_saved: "Назву оновлено.",
  admin_dt_label_required: "Назва не може бути порожньою.",
  admin_dt_load_failed: "Завантаження типів пристроїв",
  admin_dt_save_failed: "Оновлення назви",
  admin_dt_readonly_hint: "Лише суперадміністратори можуть перейменовувати типи.",
  sensor_climate: "Клімат",
  sensor_temperature: "Температура",
  sensor_humidity: "Вологість",
  sensor_last_reading: "Останнє вимірювання",
  sensor_history_title: "Температура та вологість (48 год)",
  sensor_history_empty_title: "Вимірювань ще немає",
  sensor_history_empty_sub: "Призначте цій кімнаті датчик H4 Pro, щоб бачити історію клімату.",
  admin_thresholds_title: "Пороги датчиків",
  admin_thresholds_desc: "Межі тривог температури та вологості для датчиків H4 Pro цієї організації.",
  admin_thresholds_temp_min: "Мін. температура",
  admin_thresholds_temp_max: "Макс. температура",
  admin_thresholds_hum_min: "Мін. вологість",
  admin_thresholds_hum_max: "Макс. вологість",
  admin_thresholds_temp_invalid: "Мін. температура має бути нижчою за макс.",
  admin_thresholds_hum_invalid: "Мін. вологість має бути нижчою за макс.",
  admin_thresholds_hint: "Усі чотири необов'язкові — залиште поле порожнім, щоб не було тривоги для цієї межі.",
  admin_thresholds_cooldown: "Пауза між тривогами",
  admin_thresholds_cooldown_placeholder: "За замовчуванням: 30 хв",
  admin_thresholds_cooldown_help: "Хвилини між повторними тривогами датчика. Залиште порожнім для системного значення (30 хв).",
  admin_thresholds_cooldown_invalid: "Пауза має бути цілим числом, щонайменше 1 хвилина.",
  admin_thresholds_saved: "Пороги збережено.",
  admin_thresholds_load_failed: "Завантаження порогів",
  admin_thresholds_save_failed: "Збереження порогів",
  room_activity_view_all: "Усі події",
  role_super_admin: "Суперадміністратор",
  assign_device: "Призначити пристрій",
  select_device: "Виберіть пристрій…",
  admin_patient_no_devices_assigned: "Немає призначених пристроїв.",
  admin_patient_no_wearables: "У цій організації немає доступних носимих пристроїв.",
  admin_patient_device_reassign: "перепризначити",
  recent_critical_alerts_title: "Останні критичні тривоги",
  rooms_building_clear: "Скинути фільтр",
  buildings_title: "Будівлі",
  buildings_sub: "Кожна будівля під вашим наглядом — з кімнатами, мешканцями та пристроями.",
  buildings_view_rooms: "Переглянути кімнати",
  wt_title: "Тижнева тенденція",
  wt_desc: "Сім ночей поруч для кожного мешканця — або спільної кімнати — щоб помітити неспокійні чи незвично нерухомі ночі.",
  wt_baseline_note: "кожну ніч порівняно з медіаною рядка за 7 ночей",
  wt_no_sensors: "Жоден мешканець ще не має датчика руху.",
  wt_flag_restless: "Неспокійна",
  wt_flag_still: "Незвично нерухома",
  wt_flag_nodata: "Немає даних",
  wt_flag_silent: "Датчик майже мовчав",
  rep_sensor_silent: "Датчик передавав дані лише {pct}% цієї ночі. Пропуски означають, що датчик перестав передавати дані, а не що мешканець був нерухомий.",
  wt_legend_active: "Активні 5-хв вікна",
  wt_legend_still: "Найдовша нерухомість (год)",
  fap_title: "Родичі можуть обробляти сповіщення",
  fap_desc: "Якщо ввімкнено, родичі можуть підтверджувати, закривати, повторно відкривати та коментувати сповіщення своїх підопічних в {org}.",
  note_saved: "Нотатку збережено",
  event_device_silent: "Датчик мовчить",
  event_no_movement: "Немає руху",
  event_no_rise: "Немає руху після ночі",

  dur_lt_min: "менше хвилини",
  dur_min: "{m} хв",
  dur_h: "{h} год",
  dur_h_min: "{h} год {m} хв",
  am_fall: "Виявлено падіння",
  am_sos: "Натиснуто кнопку SOS",
  am_low_battery: "Низький заряд батареї пристрою",
  am_low_battery_dev: "Низький заряд батареї: {device}",
  am_door: "Двері відчинені",
  am_door_in: "Двері відчинені: {place}",
  am_door_in_detail: "Двері відчинені: {place} ({detail})",
  am_window: "Вікно відчинене",
  am_window_in: "Вікно відчинене: {place}",
  am_window_in_detail: "Вікно відчинене: {place} ({detail})",
  am_silent: "Датчик руху в {place} не передає дані близько {dur} — перевірте живлення або шлюз",
  am_silent_nodur: "Датчик руху в {place} перестав передавати дані — перевірте живлення або шлюз",
  am_nomove: "У {place} не виявлено руху близько {dur}",
  am_nomove_nodur: "У {place} не виявлено руху",
  am_norise: "У {place} не виявлено руху з кінця ночі (зазвичай встає до {time})",
  am_norise_notime: "У {place} не виявлено руху з кінця ночі",
  amf_silent_res: "Датчик руху ({name}) не передає дані з {time}, тому зараз рух не відстежується.",
  amf_silent_room: "Датчик руху в {place} не передає дані з {time}, тому зараз рух там не відстежується.",
  amf_sensor_ok: "Датчик працює; він просто не бачив, щоб хтось рухався.",
  amf_team: "Команду догляду попереджено на її панелі.",
  amf_contact_device: "Ви вказані контактною особою для цього пристрою.",
  amf_contact_resident: "Ви вказані контактною особою: {name}.",
  al_tab_care: "Догляд",
  al_tab_maint: "Обслуговування",
  al_maint_hint: "Датчики, що замовкли, і розряджені батареї: технічна робота, а не події догляду.",
  al_maint_empty: "Проблем із датчиками та батареями немає.",
  al_auto_closed: "Закрито автоматично",
  al_auto_closed_reason: "Закрито автоматично — {reason}",
  al_never_seen: "ніхто не бачив його до закриття",
  al_resolved_by: "Вирішено: {name}",
  al_reason_movement: "рух відновився",
  al_reason_sensor: "датчик знову передає дані",
  al_admin_only_ack: "Це сповіщення може обробити лише адміністратор, бо воно не пов’язане з одним підопічним.",
  why_title: "Чому це спрацювало?",
  why_since_motion: "З останнього руху",
  why_since_sample: "З останніх даних датчика",
  why_threshold: "Поріг",
  why_up_by: "Зазвичай встає до",
  why_night: "Нічне вікно",
  why_source: "Поріг задано",
  why_src_org: "цією організацією",
  why_src_default: "значеннями за замовчуванням",
  why_state: "Стан датчика",
  why_checked: "Перевірено о",
  why_approx: "Перевірки відбуваються кожні 5 хвилин, тому час сповіщень приблизний.",
  mon_label: "Відстеження руху",
  mon_active: "активне",
  mon_down: "немає даних",
  mon_down_since: "немає даних з {time}",
  admin_alerts_up_by_label: "Зазвичай встає до",
  admin_alerts_up_by_question: "Якщо між кінцем ночі та цим часом руху не видно, створюється сповіщення «немає руху з кінця ночі».",
  admin_alerts_up_by_invalid: "Має бути пізніше кінця ночі ({end}): це година, коли підопічні зазвичай уже встали, після ночі.",
  admin_alerts_up_by_format: "Введіть час у форматі ГГ:ХХ.",
  admin_alerts_escalation_label: "Повідомити родину про датчик, що замовк, через",
  admin_alerts_escalation_question: "Персонал бачить датчик, що замовк, одразу. Родині повідомляють, лише якщо після цього часу проблему не вирішено (одразу, якщо в організації немає доглядальників).",
  admin_alerts_cooldown_note: "Після закриття сповіщення те саме сповіщення може повернутися, коли поріг знову буде перевищено. Ранкове сповіщення спрацьовує не частіше ніж раз на день.",
  admin_alerts_stored_invalid: "Збережений час ({up}) не пізніше кінця ночі ({end}), тому ранкові сповіщення не працюють, і цю політику не можна зберегти, доки це не виправлено.",
  admin_alerts_defaults_badge: "Значення за замовчуванням",

  fap_auto_on: "Автоматично: увімкнено, бо в організації немає доглядальників.",
  fap_auto_off: "Автоматично: вимкнено, бо в організації є доглядальники.",
  fap_manual: "Встановлено адміністратором.",
  fap_reset: "Повернути автоматичний режим",
  fap_saved: "Збережено",
  fap_save_failed: "Не вдалося зберегти. Спробуйте ще раз.",
  fap_pending: "Незабаром",
  fap_retry: "Повторити",
  recap_title: "Ранковий нічний підсумок",
  recap_desc_staff: "Щодня о 07:00 (за часом організації) підсумок минулої ночі для кожного мешканця вашої організації.",
  recap_desc_family: "Щодня о 07:00 (за часом організації) підсумок минулої ночі ваших близьких.",
  recap_on: "Увімкнено",
  recap_off: "Вимкнено",
  recap_email: "Email",
  recap_telegram_link_first: "Підключіть Telegram вище, щоб отримувати його там.",
  recap_no_channel: "Виберіть хоча б один канал, інакше нічого не буде надіслано.",
  recap_last_sent: "Востаннє надіслано {at}",
  recap_saved: "Налаштування збережено.",
  recap_save_failed: "Не вдалося зберегти налаштування.",
  recap_unavailable: "Незабаром",
  topbar_org_label: "Організація",
  device_ota_phase2: "Розгортання OTA стане інтерактивним на 2-му етапі.",
  event_window_open: "Вікно відчинено",
  event_window_close: "Вікно зачинено",
  event_alarm_end: "Тривогу завершено",
  wt_h: "год",
  wt_load_failed: "Не вдалося завантажити історію руху. Спробуйте пізніше.",
  recap_load_failed: "Не вдалося завантажити налаштування — торкніться, щоб повторити.",
  mv_shared_note: "Цей мешканець ділить кімнату. Кімнатний датчик не розрізняє мешканців, тому рух показано для кімнати, а не для однієї людини.",
  mv_shared_link: "Рух у кімнаті {room}",
  mv_room_shared_note: "Спільна для {n} мешканців — цей рух не можна приписати жодному з них.",
  rep_shared_room_row: "Спільна кімната · {names}",
  admin_motion_resident: "Приліжковий датчик мешканця",
  admin_motion_resident_hint: "Необов'язково. Виберіть мешканця, лише якщо датчик спостерігає його особистий простір (напр., спрямований на ліжко). Тоді його графіки руху використовуватимуть його навіть у спільній кімнаті.",
  admin_motion_whole_room: "Уся кімната",
};
export default uk;
